<template>
  <div class="notification">
    <!-- <div>
      <div
        v-if="entity.assignee.photo"
        :style="{
          backgroundImage: `url(${staticUrl}${entity.assignee.photo})`,
        }"
        class="photo d-inline-block shadow-sm"
        :class="{
          doconline: entity.assignee && isOnline(entity.assignee.id),
        }"
      ></div>
    </div> -->
    <div
      class="row no-gutters align-items-center position-relative overflow-hidden"
    >
      <div class="col-auto text-primary border-right p-3 h-100">
        <div
          v-if="entity.assignee.photo"
          :style="{
            backgroundImage: `url(${staticUrl}${entity.assignee.photo})`,
          }"
          class="photo d-inline-block shadow-sm rounded-circle"
          :class="{
            doconline: entity.assignee && isOnline(entity.assignee.id),
          }"
        ></div>
      </div>
      <div class="col mb-2 p-3">
        <small class="text-muted" v-if="entity.assignee">
          {{ $t(action) }}
          {{ entity.assignee.firstname[authLocale] }}
          {{ entity.assignee.lastname[authLocale] }}
        </small>
        <h4 class="svg svg-upper">
          <!-- <online-consultation-icon
            v-if="entity.clinic_service.type === 'telemedicine'"
          ></online-consultation-icon>
          <clinic-icon
            v-else-if="entity.clinic_service.type === 'visit'"
          ></clinic-icon>
          <ambulance-icon
            v-else-if="entity.clinic_service.type === 'house_call'"
          ></ambulance-icon> -->
          {{ $t(entity.clinic_service.type) }}
          {{ entity.clinic_service.name[authLocale] }}
          <small class="d-block">
            {{ entity.start_time | moment("ddd, DD MMMM, HH:mm") }}
          </small>
        </h4>
        <small class="d-block text-muted">
          {{ entity.created_at | moment("from", "now") }}
        </small>
      </div>
      <div class="col-12 w-100"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
// import ClinicIcon from '@/components/Icons/Clinic'
// import AmbulanceIcon from '@/components/Icons/Ambulance'
export default {
  // components: {
  //   OnlineConsultationIcon,
  //   ClinicIcon,
  //   AmbulanceIcon
  // },
  props: {
    entity: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authLocale: 'auth/locale',
      isOnline: 'status/isOnline'
    })
  }
}
</script>

<style lang="scss">
.notification {
  .photo {
    width: 100%;
    padding-top: 56.25%;
    background-size: cover;
    background-position: center;
  }
  .month {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 80px;
    font-size: 0.75em;
  }
  .day {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 44px;
    font-size: 2em;
  }
  svg {
    width: 75px;
    // height: 100px;
  }
}
</style>
<i18n>
{
  "ka": {
    "ScheduleActivated": "",
    "doctor": "ექიმი",
    "telemedicine": "ონლაინ",
    "visit": "კლინიკაში",
    "house_call": "გამოძახება",
    "experience": "წლის გამოცდილება"
  },
  "en": {
    "ScheduleActivated": "",
    "doctor": "Doctor",
    "telemedicine": "Online",
    "visit": "At Clinic",
    "house_call": "House Call",
    "experience": "Years of Experience"
  }
}
</i18n>
